var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProvide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    className: "provide_svg__ywnoU",
    viewBox: "0 0 32 32",
    "aria-hidden": "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 18.933l8.8-8.8L24 12 13.333 22.667 8 17.333l1.867-1.866 3.466 3.466zM28 6.667v8c0 7.333-5.067 14.266-12 16-6.933-1.734-12-8.667-12-16v-8l12-5.334 12 5.334zM25.333 8.4L16 4.267 6.667 8.4v6.267c0 6 4 11.6 9.333 13.2 5.333-1.6 9.333-7.2 9.333-13.2V8.4z"
  })));
}
export default SvgProvide;